module.exports = __webpack_public_path__ + "static/media/home-swipe-one.3d0d838b.png";